<script lang="ts">
  import Link from 'svelte-link';
  import {  Col} from 'sveltestrap';
  import { href, MyProfile } from '../../../../utils/Constant/Constant';
  import Card from '../../../Core/Card.svelte';
  import UserEditForm from './UserEditForm.svelte';
</script>
  
<Col xl="4">
  <Card cardHeaderprops="pb-0">
    <div slot="customheader">
      <h4 class="card-title mb-0">{MyProfile}</h4>
      <div class="card-options">
        <Link class="card-options-collapse" {href} >
          <i class="fe fe-chevron-up" />
        </Link>
        <Link class="card-options-remove" {href} >
          <i class="fe fe-x" />
        </Link>
      </div>
    </div>
    <div slot="contentbody">
      <UserEditForm />
    </div>
  </Card>
</Col>
  
